import { ChangeEvent, FC, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/form/button';
import Input from '../../components/form/input';
import useAuth, { IncorrectCredentialsError } from '../../hooks/auth';
import useRouter from '../../hooks/router';
import { logger } from '../../utils/logger';
import styles from './styles.module.css';

const LoginView: FC = () => {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const { login, isLoading } = useAuth();
  const [error, setError] = useState('');
  const router = useRouter();

  const handleUpdate = (type: 'user' | 'pass') => (e: ChangeEvent<HTMLInputElement>) => {
    if (type === 'user') return setUser(e.target.value);
    return setPass(e.target.value);
  };

  const handleLogin = async () => {
    // reset error
    setError('');

    try {
      await login({ user, pass });
      router.replace('/');
    } catch (err: any) {
      err.message = `Login error: ${err?.message}`;
      setError(err.message);
      if (!(err instanceof IncorrectCredentialsError)) {
        logger.error(err);
      }
    }
  };

  return (
    <div className={styles.wrapper}>
      {Boolean(error) && <div className={styles.error}>Error: {error}</div>}

      <Input.Field
        className={styles.input}
        placeholder="Email address"
        value={user}
        onChange={handleUpdate('user')}
        disabled={isLoading}
      />

      <Input.Field
        className={styles.input}
        placeholder="Password"
        type="password"
        value={pass}
        onChange={handleUpdate('pass')}
        disabled={isLoading}
      />

      <div className="buttons">
        <Link to="/users/forgot">
          <Button style={{ marginRight: '1.5rem' }}>Forgot Password?</Button>
        </Link>

        <Button
          variant="dark"
          type="submit"
          onClick={handleLogin}
          disabled={isLoading}
          isLoading={isLoading}
          dot="green">
          Login
        </Button>
      </div>
    </div>
  );
};

export default LoginView;
